




















import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { AcgnFormTitle, AcgnFormContent } from '@/components';
import { Cascader } from 'element-ui';
import {
  AcgnStatisticStaffCard,
  AcgnStatisticChart,
  AcgnStatisticStaffCardm,
  AcgnStatisticStaffChartd,
  AcgnStaffCake,
  AcgnStatisticProjectAll,
  AcgnStatisticProjectLinkSettle,
} from './components';
import { Tabs, TabPane } from 'element-ui';

import { PermissionUtil } from '@acgn/herm/src/util';

const AuthGetter = namespace('desk/auth').Getter;

// 员工统计
@Component({
  components: {
    AcgnFormTitle,
    AcgnFormContent,
    AcgnStatisticStaffCard,
    AcgnStatisticChart,
    AcgnStatisticStaffCardm,
    AcgnStatisticStaffChartd,
    AcgnStatisticProjectAll,
    AcgnStatisticProjectLinkSettle,
    AcgnStaffCake,
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [Cascader.name]: Cascader,
  },
})
export default class AcgnStatisticProject extends Vue {
  public name: string = 'AcgnStatisticProject';

  @Prop({ default: true }) public isShowManage: boolean; // 是否显示管理方（显示管理方才显示成员筛选）
  @Prop({ default: null }) public comicId: number | null; // 项目id (有项目id才有目标进度)
  @Prop({ default: '' }) public projectName: string; // 项目名称

  @AuthGetter private permissions: any;

  private activeName: string = 'first';
  // 如果第一个tab没权限被，那么激活的是第二个tab
  private isFirstShow() {
    this.activeName = this.isPermission('6011') ? 'first' : 'second';
  }

  private async created() {
    this.isFirstShow();
  }

  //  判断是否有权限，由于el-tab-pane没办法用display隐藏，用不了v-acgn-permission
  private isPermission(value: any) {
    let permissionArray: string[] = [];
    if (typeof value === 'string') {
      permissionArray = (value as string).split(/\s*,\s*/g);
    } else if (Array.isArray(value)) {
      permissionArray = value;
    }
    const userPermissions = this.permissions as PermissionKey[];

    return PermissionUtil.isPermissionsAuthorizedSync(
      permissionArray,
      userPermissions,
    );
  }

  private tabClick(tab: any, event: any) {
      //  console.log('tabClick');
      //  let nodeList =document.querySelectorAll(".el-table__body-wrapper");
      //   console.log(nodeList.length);
      //  nodeList.forEach((value,key,parent)=>{
      //      console.log(JSON.stringify(value.classList));
      //       value.style.height = "400px";
      //  });
  }
}
